//Sentenze/2004/12/30/
import Carousel from 'nuka-carousel'
import PropTypes from 'prop-types'
import React, { createRef } from 'react'
import { Col, Row } from 'react-flexbox-grid'
import { connect } from 'react-redux'
import { Accordion, Button, Container, Dropdown, Form, Grid, Header, Icon, Modal, Popup, Segment, TextArea, Label, Ref, Sticky, Rail } from 'semantic-ui-react'
import smoothscroll from 'smoothscroll-polyfill'
import { backendService } from '../../services/backendService'
import { Text, Translate, LanguageContext } from '../../helpers/language';
import _ from 'lodash'
import { NotificationManager } from 'react-notifications';


class SearchResult extends React.Component {
  stickyRef = createRef()

  constructor(props) {
    super(props)
    smoothscroll.polyfill();
    this.getFeedback = this.getFeedback.bind(this)

    this.state = {
      isFullTextOpen: false,
      modalFoldersOpen: false,
      thumbDownText: '',
      bookmarkText: '',
      errorArea: true,
      errorAreaFolder: true,
      isNegativeFeedbackPopupOpen: false,
      isFolderCreationFormOpen: false,
      searchedElements: _.map(this.props.projects.sort(function (a, b) {
        if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      }), (project, i) => ({
        key: project.name, // text + key
        text: project.name, // text + key
        value: project.project_id
      })),
      isAddResutToFolderOpen: false,
      showFoldersCreation: false,
      desired_project_name: '',
      project_name: '',
      project_id: '',
      feedback: this.props.result.feedback ? this.props.result.feedback: 'none',
      document: this.props.result.document ? this.props.result.document: null,
      loadingDoc: false,
      preloadDoc: false,
    }
  }

  componentDidUpdate(prevProps) {
    if (typeof this.props.addElement !== 'undefined' && typeof prevProps.projects !== 'undefined' && typeof this.props.projects !== 'undefined' && prevProps.projects.length !== this.props.projects.length) {
      this.setState({
        searchedElements: _.map(this.props.projects.sort(function (a, b) {
          if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
          if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
          return 0;
        }), (project, i) => ({
          key: project.name, // text + key
          text: project.name, // text + key          
          value: project.project_id
        }))
      })
    }
  }

  /**
   * 
   * @param {*} id 
   * @param {*} article_type 
   * @param {*} e 
   * @param {*} titleProps 
   */
  async handleDocumentTextAccordionClick(id, article_type, e, titleProps) {
    const openArticle = this.state.isFullTextOpen === true ? false : true;
    if(openArticle) {
      document.addEventListener('scroll', this.computeStickyElementPosition.bind(this))
      window.addEventListener('resize', this.computeStickyElementPosition.bind(this))
    } else {
      document.removeEventListener('scroll', this.computeStickyElementPosition.bind(this))
      window.removeEventListener('resize', this.computeStickyElementPosition.bind(this))
    }
    await this.setState({ isFullTextOpen: openArticle })
    if(openArticle)
      this.computeStickyElementPosition()
  }

  /**
   * 
   * @param {*} e 
   * @param {*} index 
   */
  async handleSyntheticPrincipleClick(e, index) {
    e.preventDefault()
    if (!this.state.isFullTextOpen) {
      await document.getElementById('titleHighlight-' + index).click()
    }
    setTimeout(() => {
      const element = document.getElementById("synthetic_highlight_" + this.props.i);
      const bodyRect = document.body.getBoundingClientRect().top;
      const height = window.innerHeight / 5
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      var offsetPosition = elementPosition - height; //1/5th of the height

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    });
  }

  /**
   * 
   * @param {*} e 
   * @param {*} index 
   */
  handleVerdictCloseClick(e, index) {
    e.preventDefault()
    
    setTimeout(() => {
      const resElement = document.getElementById('result-' + index)
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = resElement.getBoundingClientRect().top;
      const height = window.innerHeight / 5
      const elementPosition = elementRect - bodyRect;
      var offsetPosition = elementPosition - height;  //1/5th of the height      

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })

      const element = document.getElementById('titleHighlight-' + index)
      if (this.state.isFullTextOpen) {      
        element.click()
      }
    });
  }

  /**
   * 
   */
  computeStickyElementPosition() {
    let stickyId = 'return_button_' + this.props.i
    let accordionId = 'document_text_' + this.props.i
    const element = document.getElementById(stickyId)
    const parent = document.getElementById(accordionId)
    if (this.state.isFullTextOpen && parent && element) { 
      const top = parent.getBoundingClientRect().top;
      const bottom = parent.getBoundingClientRect().bottom;
      let topOffset = window.innerHeight - top
      const topOffsetMargin = 150
      let bottomOffset = window.innerHeight - bottom
      if (topOffset < topOffsetMargin)
        element.style.bottom = (topOffset - topOffsetMargin) + 'px'
      else if (bottomOffset > 0)
        element.style.bottom = bottomOffset + 'px'
      else 
        element.style.bottom = '0px'
    }

  }

  /**
   * display result
   * @param {*} document_text 
   */
  highlightSyntheticPrinciple(document_text, startIndex, endIndex) {
    var text = _.cloneDeep(document_text).replace(/\r/g,"")
    if (startIndex >= 0 && endIndex < text.length) {
      text = text.substring(0, startIndex) + "{HIGHLIGHT_BEGIN}" + this.putKeywordHighlights(text.substring(startIndex, endIndex), this.props.result.keywords_positions) + "{HIGHLIGHT_END}" + text.substring(endIndex)
    }
    
    text = text.replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;")
      .replace(/\n|\r\n/g,"<br>")
      .replace(/ {2}/g, "&nbsp;&nbsp;")
      .replace(/\{HIGHLIGHT_BEGIN\}/g, "<span id='synthetic_highlight_" + this.props.i + "' class='search-enlight'>")
      .replace(/\{HIGHLIGHT_END\}/g, "</span>")
      .replace(/\{KEYWORD_HIGHLIGHT_BEGIN\}/g, "<span id='keyword_highlight_" + this.props.i + "' class='search-keyword-enlight'>")
      .replace(/\{KEYWORD_HIGHLIGHT_END\}/g, "</span>");    
    return text
  }

  /**
   * display result
   * @param {*} document_text 
   */
  formatVerdict(document_text, startIndex, endIndex) {
    var text = _.cloneDeep(document_text)
    text = text.replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;")
      .replace(/\n|\r\n/g,"<br>")
      .replace(/ {2}/g, "&nbsp;&nbsp;")
          
    return text
  }

  /**
   * 
   * @param {*} principle_text 
   * @param {*} indexes 
   */
  putKeywordHighlights(principle_text, indexes) {
    if (!indexes)
      return principle_text;
    let text = '';
    let indexCount = 0;
    let lastIndex = 0;
    indexes.forEach( curIndex => {
      let startIndex = curIndex.startPosition - 1 ;
      let endIndex = curIndex.endPosition - 1;
      if (startIndex >= 0 && endIndex < principle_text.length) {
        text += principle_text.substring(lastIndex, startIndex) + "{KEYWORD_HIGHLIGHT_BEGIN}" + principle_text.substring(startIndex, endIndex) + "{KEYWORD_HIGHLIGHT_END}";
        indexCount++;
        lastIndex = endIndex;
      }
    });
    text += principle_text.substring(lastIndex);
    return text;
  }

  /**
   * highlight keywords in principle text
   * @param {*} principle_text 
   * @param {*} indexes 
   * @returns 
   */
  highlightKeywordsInPrinciple(principle_text, indexes) {
    if (!indexes)
      return principle_text;
    let text = this.putKeywordHighlights(principle_text, indexes)   
    text = text.replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;")
    .replace(/\{KEYWORD_HIGHLIGHT_BEGIN\}/g, "<span id='keyword_highlight_" + this.props.i + "' class='search-keyword-enlight'>")
    .replace(/\{KEYWORD_HIGHLIGHT_END\}/g, "</span>");
          
    return text
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loading_article === true) {
      this.setState({ thumbDownText: '', bookmarkText: '', project_name: '', showFoldersCreation: false, errorArea: true, errorAreaFolder: true, isNegativeFeedbackPopupOpen: false, modalFoldersOpen: false, isAddResutToFolderOpen: false })
    }
  }

  getColor(value) {
    const hue = ((value) * 120).toString(10)
    return ["hsl(", hue, ",100%,50%)"].join("")
  }


  loader() {
    return (
      <Row>
        <Col xs={12} className='pad20'>
          <div id="fountainG">
            <div id="fountainG_1" className="fountainG"></div>
            <div id="fountainG_2" className="fountainG"></div>
            <div id="fountainG_3" className="fountainG"></div>
            <div id="fountainG_4" className="fountainG"></div>
            <div id="fountainG_5" className="fountainG"></div>
            <div id="fountainG_6" className="fountainG"></div>
            <div id="fountainG_7" className="fountainG"></div>
            <div id="fountainG_8" className="fountainG"></div>
          </div>
        </Col>
      </Row>
    )
  }


  /**
   * feedback management
   */
  handleThumbUpClick = () => {
    switch (this.state.feedback) {

      case 'positive':
        this.props.deleteFeedback(this.props.result.id_new, function () {
          // refresh user feedbacks
          this.getFeedback();
        });
        break;

      default:
        this.props.createFeedback(this.props.result.id_new, JSON.stringify(this.props.result), true, this.props.query, Translate(this.context, 'result_feedback_positive'), function () {
          // refresh user feedbacks
          this.getFeedback();
        })
        break;
    }
  }

  handleThumbDownClick = () => {
    switch (this.state.feedback) {

      case 'negative':
        this.props.deleteFeedback(this.props.result.id_new, function () {
          // refresh user feedbacks
          this.getFeedback();
        });
        break;

      default:
        break;
    }
  }

  handleNegativeFeedbackPopupOpen = () => this.setState({ isNegativeFeedbackPopupOpen: true })

  handleNegativeFeedbackPopupClose = () => this.setState({ isNegativeFeedbackPopupOpen: false })

  handleNegativeFeedbackSubmit = () => {
    const self = this

    if (this.state.thumbDownText !== '') {
      this.props.createFeedback(this.props.result.id_new, JSON.stringify(this.props.result), false, this.props.query, this.state.thumbDownText, function () {
        self.setState({ errorArea: true, thumbDownText: '', isNegativeFeedbackPopupOpen: false })
        // refresh user feedbacks
        self.getFeedback();
        NotificationManager.success(Translate(self.context, 'result_feedback_thanks'))
      })
    }
  }

  /**
   * get user feedbacks
   */
  async getFeedback() {
    const response = await backendService.get(`/api/feedbacks?user=${this.props.auth.user.email}&idResult=${this.props.result.id_new}`);
    if (response.data) {
      if (response.data.positive === true) {
        this.setState({ feedback: 'positive' })
      } else {
        this.setState({ feedback: 'negative' })
      }
    } else {
      this.setState({ feedback: 'none' })
    }
  }

  /**
   * user's folders management
   */

  handleShowFolderCreation = () => this.setState({ showFoldersCreation: true })

  handleHideFolderCreation = (e) => {
    e.preventDefault()
    this.setState({ showFoldersCreation: false })
  }
  
  handleOpenFoldersPopup = () => this.setState({ isAddResutToFolderOpen: true })

  handleAddResultToFolder = () => {
    const self = this

    this.props.addElement(this.state.project_id, this.state.project_name, JSON.stringify(this.props.result), this.props.result.id_new, function (folder) {
      NotificationManager.success(Translate(self.context, 'result_saved_description') + ' ' + folder)
      self.setState({ isAddResutToFolderOpen: false })
    })
  }

  handleCloseFoldersPopup = () => {
    this.setState({ isAddResutToFolderOpen: false, project_name: '', project_id: '' })
  }

  handleFolderCreationFormClose = () => this.setState({ project_name: '', isFolderCreationFormOpen: false })

  handleCloseFolders = () => this.setState({ modalFoldersOpen: false })

  handleFolderCreation = () => {
    const self = this

    if (this.state.bookmarkText !== '' && this.state.desired_project_name !== '') {
      this.props.createFolder(this.state.desired_project_name, this.state.bookmarkText, JSON.stringify(this.props.result), this.props.result.id_new, function (folder) {
        self.setState({ isFolderCreationFormOpen: false, errorAreaFolder: true, bookmarkText: '', isAddResutToFolderOpen: false, showFoldersCreation: false, desired_project_name: '' })
        NotificationManager.success(Translate(self.context, 'result_saved_description') + ' ' + folder)
      })
    }
  }

  handleChange = async (e, { name, value }) => {
    this.setState({ [name]: value })
    if (value !== '') {
      if (name === 'thumbDownText') {
        await this.setState({ errorArea: false })
      } else if (name === 'bookmarkText' && this.state.desired_project_name !== '') {
        await this.setState({ errorAreaFolder: false })
      } else if (name === 'caso' && this.state.bookmarkText !== '') {
        await this.setState({ errorAreaFolder: false })
      }
    } else {
      if (name === 'thumbDownText') {
        await this.setState({ errorArea: true })
      } else {
        await this.setState({ errorAreaFolder: true })
      }
    }
  }

  handleFolderCreateOpen = (e, data) => {
    if (e.type === 'click') {
      this.setState({ isAddResutToFolderOpen: false, isFolderCreationFormOpen: true })
    }
  }

  handleDeleteElement = () => {
    this.props.handleDeleteElement(this.props.result.id_new)
  }

  handleSearchFolder(e, target) {
    let newFolderValue = target.searchQuery

    if (newFolderValue.length > 255) {
      newFolderValue = newFolderValue.substring(0, 255) ;
    }

    let newId = ''
    const selectedItem = this.state.searchedElements.find((element) => { return element.text === target.newFolderValue })
    if (selectedItem)
      newId = selectedItem.value

    this.setState({ project_name: newFolderValue, project_id: newId, desired_project_name: target.searchQuery })
  }

  handleFolderValueChanged(e, target) {
    let newFolderValue = target.value
    let newName = ''
    const selectedItem = this.state.searchedElements.find((element) => { return element.value === target.value })
    if (selectedItem)
      newName = selectedItem.text
    this.setState({ project_id: newFolderValue, project_name: newName })
  }

  resetProjectName() {
    this.setState({ project_name: '' })
  }

  capitalizeFirstLetter(str) {
    if (!str) return str; // Return if string is empty or null
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  /**
   * format area from id to words
   * @param {*} issuer_type_id
   * @param {*} document_city
   * @param {*} document_region
   */
  formatTribunal(issuer_type_id, document_emanante, document_city, document_region) {
    if( !issuer_type_id ) {
      if (document_city && document_city !== 'nd') {
        if (document_emanante && (document_city !== 'nd') && (document_city !== 'unknown') && (document_city !== 'sconosciuto'))
          return this.capitalizeFirstLetter(document_emanante) + Translate(this.context, 'result_of_city') + ' ' + document_city
        
        return document_city;
      }
      return ''
    }

    switch (issuer_type_id) {
      //tribunale
      case 1 :
        if (document_city && document_city !== 'nd')
          return Translate(this.context, 'result_tribunal_of') + ' ' + document_city
        break;
      //corte d'appello
      case 2 : 
        if (document_city && document_city !== 'nd')
          return Translate(this.context, 'result_court_of_appeal_of') + ' ' + document_city
        break;
      //corte di cassazione
      case 3 :
        return Translate(this.context, 'result_supreme_court')    
      //giudice di pace
      case 4 :
        if (document_city && document_city !== 'nd')
          return Translate(this.context, 'result_issuer_judge') + Translate(this.context, 'result_of_city') + document_city
        else
          return Translate(this.context, 'result_issuer_judge')        
      //tribunale delle libertà
      case 5 :
        if (document_city && document_city !== 'nd')
          return Translate(this.context, 'result_freedom_tribunal') + Translate(this.context, 'result_of_city') + document_city
        else
          return Translate(this.context, 'result_freedom_tribunal')         
      //tribunale per i minori
      case 6:
        if (document_city && document_city !== 'nd')
          return Translate(this.context, 'result_minors_tribunal') + Translate(this.context, 'result_of_city') + document_city
        else
          return Translate(this.context, 'result_minors_tribunal')       
      //TAR
      case 7 :
        if (document_region && document_region !== 'nd')
          return Translate(this.context, 'result_tar') + ' ' + document_region
        else
          return Translate(this.context, 'result_tar')          
      //consiglio di stato
      case 8 :
        return Translate(this.context, 'result_state_council')        
      //ctp
      case 9 :
        if (document_city && document_city !== 'nd')
          return Translate(this.context, 'result_ctp') + Translate(this.context, 'result_of_city') + document_city
        else
          return Translate(this.context, 'result_ctp')              
      //ctr
      case 10 :
        if (document_city && document_city !== 'nd')
          return Translate(this.context, 'result_ctr') + Translate(this.context, 'result_of_city') + document_city
        else
          return Translate(this.context, 'result_ctr')                 
      //consiglio di Giustizia amministrativa
      case 12 :
        return Translate(this.context, 'result_cga')        
      default:
        if (document_city && document_city !== 'nd') {
          return Translate(this.context, 'result_tribunal_of') + ' ' + document_city
        } else {
          return ''
        }
    }
    return ''
  }

  /**
   * format area from id to words
   * @param {*} area
   */
  formatArea(area) {
    let areaText = ''
    switch (area) {
      case 1: 
        areaText = Translate(this.context, 'result_civil')
        break;
      case 2: 
        areaText = Translate(this.context, 'result_penal') 
        break; 
      case 3: 
        areaText = Translate(this.context, 'result_administrative')
        break;
      case 4:  
        areaText = Translate(this.context, 'result_tributary')
        break;
      case 5:          
        break;
      case 6:  
        areaText = Translate(this.context, 'result_work')
        break;
      case 7:  
        areaText = Translate(this.context, 'result_minors')
        break;
      case 8:  
        areaText = Translate(this.context, 'result_family')
        break;
      default:
        break;
    }   
    return areaText
  }

  /**
   * format section from number to words
   * @param {*} section
   */
  formatSection(section) {
    let sectionText = ''
    if (section.match('^\\d+$')) {
      let section_number = parseInt(section)
      if (section_number > 0 && section_number < 10) {
        switch (section_number) {
            case 1: 
              sectionText = Translate(this.context, 'result_first')
              break
            case 2: 
              sectionText = Translate(this.context, 'result_second')
              break
            case 3: 
              sectionText = Translate(this.context, 'result_third')
              break
            case 4:  
              sectionText = Translate(this.context, 'result_fourth')
              break
            case 5: 
              sectionText = Translate(this.context, 'result_fifth')
              break
            case 6: 
              sectionText = Translate(this.context, 'result_sixth')
              break
            case 7: 
              sectionText = Translate(this.context, 'result_seventh')
              break
            case 8: 
              sectionText = Translate(this.context, 'result_eighth')
              break
            case 9: 
              sectionText = Translate(this.context, 'result_ninth')
              break
            default: 
              sectionText =  ''
              break
        }
      } else if (section_number > 0) {
        sectionText =  section_number + '°'
      } 
    } else {
      sectionText = section
    }
    return sectionText
  }

  /**
   * 
   * @param {*} date 
   * @returns 
   */
  formatDate(date) {
    try {
      let splits = date.split('-')
      if (splits.length === 3) {
        const d = new Date(splits[0], splits[1] - 1, splits[2]);
        const ye = new Intl.DateTimeFormat('it', { year: 'numeric' }).format(d);
        const mo = new Intl.DateTimeFormat('it', { month: 'long' }).format(d);
        const da = new Intl.DateTimeFormat('it', { day: '2-digit' }).format(d);
        return `${da} ${mo} ${ye}`;        
      } else {
        return date
      }
    } catch (exc) {
      return date;
    }
  }

  renderResultActions(hasDocumentText) {
    const project_name = this.state.project_name
    const project_id = this.state.project_id
    const thumbDownText = this.state.thumbDownText
    const bookmarkText = this.state.bookmarkText
    return (
      <>
        <Grid columns={2} stretched className='sidebarDoc'>
                  { hasDocumentText ?
                    (<Grid.Column width={8} id={'titleHighlight-' + this.props.i}
                      index={this.props.i}
                      key={'title-' + this.props.i}
                      className='result-title'
                      onClick={(e, titleProps) => { this.handleDocumentTextAccordionClick(this.props.result.id, this.props.article_type, e, titleProps) }}>
                      <Container textAlign='left'>
                        <Icon className={this.state.isFullTextOpen ? 'caret down' : 'caret right'} />
                        {<Text tid='result_full_verdict'/>}
                      </Container>
                    </Grid.Column>) : (
                      <Grid.Column width={8} id={'titleHighlight-' + this.props.i}>
                        <Container textAlign='left'>
                        <Popup content={Translate(this.context, 'available_soon')} trigger={
                          <div style={{color: 'grey'}} >
                            <Icon className={'caret right'}/>                      
                            {<Text tid='result_full_verdict'/>}
                          </div>
                        } />
                          
                      </Container>
                      </Grid.Column>
                    )
                  }                    
                  <Grid.Column width={8} className='result_action_buttons_container'>
                    <Container >
                      <Grid.Column width={4} >
                        <Segment className='segmentCentered'>
                          <div className='divCentered'>
                            <Grid columns={16} stretched className='bottBarBtns'>                        
                              <Grid.Column className='colBookmarkBtn'>
                                {typeof this.props.addElement !== 'undefined' &&
                                  <div>  
                                    <Modal
                                      size='small'
                                      open={this.state.isFolderCreationFormOpen}
                                    >
                                      <Modal.Content>
                                        <h5><Text tid='result_folder_description_heading'/> {project_name}</h5>

                                        <Form>
                                          <TextArea name='bookmarkText' value={bookmarkText} onChange={this.handleChange} placeholder={Translate(this.context, 'result_folder_description')} />
                                        </Form>
                                      </Modal.Content>
                                      <Modal.Actions>
                                        <Button
                                          negative
                                          onClick={this.handleFolderCreationFormClose}>
                                          <Text tid='cancel' />
                                        </Button>
                                        <Button
                                          className='lisia-blue'
                                          content={Translate(this.context,'save')}
                                          onClick={this.handleFolderCreation}
                                          disabled={this.state.errorAreaFolder}
                                        />
                                      </Modal.Actions>
                                    </Modal>
                                    <Modal
                                      size='small'
                                      closeOnDimmerClick={false}
                                      open={this.state.isAddResutToFolderOpen}
                                      onOpen={this.handleOpenFoldersPopup}
                                      onClose={this.resetProjectName}
                                      trigger={<span><Icon name='bookmark outline' size='large' className='buttonsCentering hvr-grow' on='click' /><span className="salvaBookmark"><Text tid='save' /></span></span>}
                                    >
                                      <Modal.Content>
                                        <h5><Text tid='result_add_to_existing' /></h5>
                                        { this.state.project_name.length > 50  &&
                                          <Label basic color='red' pointing='below'>
                                            <Text tid='result_folder_name_limit_exceeded' />
                                          </Label>
                                        }
                                        <Dropdown
                                          placeholder={Translate(this.context,'result_folder_select')}
                                          noResultsMessage=''
                                          onChange={(e, data) => { this.handleFolderValueChanged(e, data) }}
                                          onAddItem={(e, data) => { this.handleFolderCreateOpen(e, data) }}
                                          onSearchChange={(e, data) => { this.handleSearchFolder(e, data) }}
                                          value={project_id}
                                          text={project_name}
                                          searchQuery={project_name}
                                          fluid
                                          search
                                          allowAdditions
                                          additionLabel={Translate(this.context,'result_folder_create') + ' '}
                                          selection
                                          options={this.state.searchedElements}
                                          error={this.state.project_name.length > 50}
                                        />                                   

                                      </Modal.Content>
                                      <Modal.Actions>
                                        <Button negative onClick={this.handleCloseFoldersPopup}><Text tid='cancel' /></Button>
                                        <Button
                                          className='lisia-blue'
                                          content={Translate(this.context,'save')}
                                          disabled={project_id === '' || project_name === ''}
                                          onClick={this.handleAddResultToFolder}
                                        />
                                      </Modal.Actions>
                                    </Modal>
                                  </div>
                                }
                                {typeof this.props.addElement === 'undefined' &&
                                  <Popup
                                    trigger={<span><Icon name='trash alternate outline' size='large' className='buttonsCentering hvr-grow' onClick={this.handleDeleteElement} /><span className="salvaBookmark"><Text tid='remove' /></span></span>}
                                    content={Translate(this.context,'result_folder_remove_item')}
                                    on='hover'
                                    hoverable={true}
                                    basic
                                  />
                                }
                              </Grid.Column>

                              <Grid.Column>
                                {
                                  this.state.feedback !== 'negative' ? (
                                    <Popup
                                      trigger={<Icon name='thumbs down' size='large' onClick={this.handleThumbDownClick}
                                      className={'buttonsCentering hvr-grow '.concat(this.state.feedback === 'negative' ? 'disabledButtonNeg' : 'outline')} />}
                                      content={<Form onSubmit={this.handleNegativeFeedbackSubmit}><TextArea name='thumbDownText' value={thumbDownText} onChange={this.handleChange} placeholder={Translate(this.context, 'result_negative_feedback_description' )} /><Button type='submit' className='lisia-blue' style={{width: '100%'}} disabled={this.state.errorArea}><Text tid='submit'/></Button></Form>}
                                      on='hover'
                                      open={this.state.isNegativeFeedbackPopupOpen}
                                      onOpen={this.handleNegativeFeedbackPopupOpen}
                                      onClose={this.handleNegativeFeedbackPopupClose}
                                      hoverable={true}
                                      basic
                                    />) : (
                                      <Icon name='thumbs down' size='large' onClick={this.handleThumbDownClick}
                                        className={'buttonsCentering hvr-grow '.concat(this.state.feedback === 'negative' ? 'disabledButtonNeg' : 'outline')} />
                                    )
                                }

                              </Grid.Column>
                              <Grid.Column>
                                {
                                  this.state.feedback !== 'positive' ? (
                                    <Popup
                                      trigger={<Icon name='thumbs up' size='large' onClick={this.handleThumbUpClick} className={'buttonsCentering hvr-grow '.concat(this.state.feedback === 'positive' ? 'disabledButtonPos' : 'outline')} />}
                                      content={Translate(this.context,'result_positive_feedback_description')}
                                      on='hover'
                                      hoverable={true}
                                      basic
                                    />) : (
                                      <Icon name='thumbs up' size='large' onClick={this.handleThumbUpClick} className={'buttonsCentering hvr-grow '.concat(this.state.feedback === 'positive' ? 'disabledButtonPos' : 'outline')} />
                                    )
                                }                              
                              </Grid.Column>

                              {
                                !(/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) ? (
                                  <Grid.Column className='printColumn'>
                                    <Icon name='print' size='large' className={'buttonsCentering hvr-grow'} onClick={() => { this.props.printResultFnc(this.props.i , this.props.result.document_type_massima) }} />
                                  </Grid.Column>
                                ) : ''
                              }

                            </Grid>
                          </div>
                        </Segment>
                      </Grid.Column>
                    </Container>
                  </Grid.Column>
                </Grid>
      </>
    )
  }

  /**
   * Render 
   */
  render() {
    const color = this.getColor(this.props.result.score)
    const style = { borderLeft: '0px solid ' + color }    
    let summary_elements = []
    let document_date = this.props.result.document_date
    let text_massima_sentenza = ''
    
    if (this.state.document) {
      if (this.props.result.document_type_massima === 1) {
        text_massima_sentenza += this.highlightSyntheticPrinciple(this.state.document.ruling_full_text, this.props.result.document_type_massima_start, this.props.result.document_type_massima_end) 
      } else {
        text_massima_sentenza += this.formatVerdict(this.state.document.ruling_full_text)
      }
    }

    // we also manage the case of null issuer_type_id
    //if (this.props.result.issuer_type_id) {
      let tribunal_text = this.formatTribunal(this.props.result.issuer_type_id, this.props.result.document_emanante, this.props.result.document_place, this.props.result.document_region)
      if (tribunal_text.length > 0)
        summary_elements.push(tribunal_text)       
    //} 

    if ((this.props.result.document_sezione || (this.state.document && this.state.document.ruling_section) ) || 
        (this.props.result.document_area && this.props.result.document_area !== 5)) {
      let section_area_elems = []
      if (this.props.result.document_sezione) 
        section_area_elems.push(this.formatSection(this.props.result.document_sezione))
      else if (this.state.document && this.state.document.ruling_section) 
        section_area_elems.push(this.formatSection(this.state.document.ruling_section))
      this.props.result.document_area && this.props.result.document_area !== 5 && section_area_elems.push(this.formatArea(this.props.result.document_area))
      if (section_area_elems.length > 0) {
        section_area_elems.unshift(Translate(this.context, 'result_section') + ' ')
        summary_elements.push(section_area_elems.join(' '))
      }
    }
    if ((this.props.result.sent_anno && this.props.result.sent_anno > 0) || document_date) {
      summary_elements.push(this.formatDate(document_date ? document_date : this.props.result.sent_anno))
    }
    if (this.props.result.sent_numero && this.props.result.sent_numero > 0) {
      summary_elements.push(Translate(this.context, 'result_verdict_number') + ' ' + this.props.result.sent_numero)  
    }
    let nrg_summary = summary_elements.join(', ')
    let hasDocumentText = text_massima_sentenza && text_massima_sentenza.length > 0
    return (      
        <div className='search-result pad20' style={style} id={'result-' + this.props.i} key={'result-' + this.props.i}>             
            <Col className='centered' >           
              <Grid stretched centered columns={1} >
                <Grid.Row>
                  <Grid.Column className='left' >
                    <Grid stretched className='result_heading_grid_container'>
                      <Grid.Row verticalAlign='middle'>
                        { this.props.result.document_type_massima === 0 || !this.props.result.document_type_massima ? 
                          <>
                          <Grid.Column width={13} className='left result_heading' id={'result_heading_' + this.props.i} >
                              {nrg_summary}
                          </Grid.Column>
                          <Grid.Column width={3} className='result_info_header_container'>
                            {Translate(this.context, 'result_is_pure_heading')}
                          </Grid.Column>
                        </>
                          :
                          <>
                            <Grid.Column width={10} className='left result_heading_synthetic' id={'result_heading_' + this.props.i} >
                                {nrg_summary}
                            </Grid.Column>
                            <Grid.Column width={6} className='result_info_header_container'>
                            <div >
                                
                                {Translate(this.context, 'result_is_synthetic_heading')}   
                                <span style = {{whiteSpace:'nowrap'}}>
                                  {Translate(this.context, 'result_is_synthetic_heading_2')}                          
                                  {/* REMOVED after 2020/11/23 update
                                    <Popup className='search_result_popup'
                                        trigger={<Icon circular size='tiny' name='info' className={'hvr-grow lisia-synthetic-info-icon'}/>}
                                        content={Translate(this.context,'result_is_synthetic')}
                                        on='hover'
                                        hoverable={true}                                
                                  />*/}
                                </span>
                              </div>
                            </Grid.Column>
                            
                          </>
                        }
                      </Grid.Row>
                    </Grid>
                    <Segment>                    
                      { this.props.result.document_type_massima === 0 || !this.props.result.document_type_massima ? 
                          <div id={'massima_carousel_' + this.props.i} className='principleCarousel' dangerouslySetInnerHTML={{
                                __html: this.highlightKeywordsInPrinciple(this.props.result.document_diritto, this.props.result.keywords_positions)
                            }}>
                          </div>
                        : 
                        <Popup className='search_result_popup'
                              hoverable={true} 
                              content={Translate(this.context, 'result_click_to_highlight_in_text')} trigger={
                                <div id={'massima_carousel_' + this.props.i} className='syntheticPrincipleCarousel' onClick={(e) => { this.handleSyntheticPrincipleClick(e, this.props.i) }} dangerouslySetInnerHTML={{
                                  __html: this.highlightKeywordsInPrinciple(this.props.result.document_diritto, this.props.result.keywords_positions)
                              }}
                        >                      
                        </div>
                        } />
                          
                      }
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              {(this.props.loading_article || this.state.loadingDoc) ? this.loader() :              
                <Accordion className='verdict_container' >              
                  <Accordion.Title>
                    { this.renderResultActions(hasDocumentText) }
                  </Accordion.Title>   
                  
                  <Accordion.Content 
                    id={'content_result_' + this.props.i}
                    className='result-content'
                    active={this.state.isFullTextOpen}                
                  >    
                         
                      <Col className='centered' xs={12} md={11} >
                          <div className="ui stuck-container fixed-container" style={{zIndex: 3}}>   
                            <div className="ui fixed bottom sticky search_result_document_text_action_container" 
                              id={'return_button_' + this.props.i}
                            >                             
                              <Button                                 
                                className='lisia-blue' 
                                icon='arrow up' 
                                onClick={(e) => { this.handleVerdictCloseClick(e, this.props.i) }} 
                                content={Translate(this.context,'result_close_and_go_up')}
                                />                       
                            </div>     
                          </div>                                                
                          <div className="full-document-div" dangerouslySetInnerHTML={{ __html: text_massima_sentenza }}  id={'document_text_' + this.props.i}>
                          </div>  
                      </Col>                
                  </Accordion.Content>       
                </Accordion>                
              }
            </Col>                   
        </div>     
    )
  }
}

SearchResult.propTypes = {
  i: PropTypes.number,
  activeIndex: PropTypes.number,
  handleClick: PropTypes.func,
  createFolder: PropTypes.func,
  createFeedback: PropTypes.func,
  deleteFeedback: PropTypes.func,
  getFeedback: PropTypes.func,
  addElement: PropTypes.func,
  result: PropTypes.object,
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  loading_article: state.articles.loading_article !== undefined ? state.articles.loading_article : false,
  article: state.articles.article !== undefined ? state.articles.article : false,
  projects: state.articles.projects !== undefined ? state.articles.projects : [],
})

SearchResult.contextType = LanguageContext;

export default connect(mapStateToProps)(SearchResult)